import React from 'react';
import { getAvatarInitials, getAvatarColors } from '../../Helpers/Avatar.js';

/**
 * UserAvatar — circular avatar with initials and a deterministic
 * per-user color.
 * Falls back to a neutral panel color when no name is given.
 *
 * Props:
 *  - user:  string (username) or { id|name, email }
 *  - email: optional string to widen the hash so two users with the same
 *           first 2 letters still get different colors
 *  - size:  'xs' | 'sm' | 'md' (default: 'sm')
 */
function UserAvatar({ user, email, size = 'sm' }) {
  const name = typeof user === 'string'
    ? user
    : (user && (user.name || user.id)) || '';
  const mail = email != null
    ? email
    : (typeof user === 'object' && user && user.email) || '';

  const initials = getAvatarInitials(name);
  const colors = getAvatarColors(name, mail);

  return (
    <span
      className={`cs-avatar cs-avatar--${size}`}
      style={{
        background: colors.bg,
        color: colors.fg,
        borderColor: colors.border,
      }}
      title={name || undefined}
      aria-hidden="true"
    >
      {initials}
    </span>
  );
}

export default UserAvatar;
